/* eslint-disable react/prop-types */
import React from 'react'
import { renderRoutes } from 'react-router-config'
import { Redirect } from 'react-router-dom'
import processRoutes from './helper'
import Firewall from '../modules/security/components/Firewall'
import Layout from '../components/Layout'
import { AssignComplaintsProvider } from '../modules/assignedComplaints/containers/AssignComplaintsProvider'
import { ComplaintsProvider } from '../modules/complaint/containers/ComplaintsProvider'
import { ContributorsProvider } from '../modules/contributor/containers/ContributorsProvider'
import { DashboardProvider } from '../modules/dashboard/container/DashboardProvider'
import { SupervisorProvider } from '../modules/Supervisor/containers/SupervisorProvider'
import { IntervenorProvider } from '../modules/Intervenant/containers/IntervenantProvider'
import { ChallengeParticipationsDashboardProvider } from '../modules/challengeParticipationDashboard/container/ChallengeParticipationsDashboardProvider'
import { ChallengeParticipationsProvider } from '../modules/challengeParticipation/containers/ChallengeParticipationsProvider'

const NotFound = () => (
  <div>
    <h3>NotFound</h3>
  </div>
)

const routes = [
  {
    component: Firewall,
    routes: [
      {
        path: '/intervenor',
        component: Layout,
        routes: [
          {
            path: '/',
            component: () => <Redirect to={{ pathname: '/intervenor/dashboard' }} />,
          },
          {
            path: '/dashboard',
            roles: ['intervenor'],
            component: ({ route }) => (
              <DashboardProvider>
                {renderRoutes(route.routes)}
              </DashboardProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(/* webpackChunkName: "dashboard" */ './Dashboard.js'),
              },
            ],
          },
          {
            path: '/assignedcomplaints',
            roles: ['intervenor'],
            component: ({ route }) => (
              <AssignComplaintsProvider>
                {renderRoutes(route.routes)}
              </AssignComplaintsProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(
                    /* webpackChunkName: "AssignedComplaints" */ './AssignedComplaints.js'
                  ),
              },
            ],
          },
          {
            path: '/change-password',
            load: () =>
              import(
                /* webpackChunkName: "change-password" */ './ChangePassword.js'
              ),
          },
          {
            path: '/login',
            load: () => import(/* webpackChunkName: "Login" */ './Login.js'),
          },
          {
            path: '/forget-password',
            load: () =>
              import(
                /* webpackChunkName: "ForgetPassword" */ './ForgetPassword.js'
              ),
          },
          {
            path: '/reset-password',
            load: () =>
              import(/* webpackChunkName: "ResetPassword" */ './ResetPassword.js'),
          },
        ]
      },
      {
        path: '/challenge',
        component: Layout,
        routes: [
          {
            path: '/',
            component: () => <Redirect to={{ pathname: '/challenge/challengeParticipationsDashboard' }} />,
          },
          {
            path: '/challengeParticipationsDashboard',
            roles: ['challengeSupervisor'],
            component: ({ route }) => (
              <ChallengeParticipationsDashboardProvider>
                {renderRoutes(route.routes)}
              </ChallengeParticipationsDashboardProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(
                    /* webpackChunkName: "ChallengeParticipationsDashboard" */ './ChallengeParticipationsDashboard.js'
                  ),
              },
            ],
          },
          {
            path: '/challengeParticipations',
            roles: ['challengeSupervisor'],
            component: ({ route }) => (
              <ChallengeParticipationsProvider>
                {renderRoutes(route.routes)}
              </ChallengeParticipationsProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(
                    /* webpackChunkName: "ChallengeParticipations" */ './ChallengeParticipations.js'
                  ),
              },
            ],
          },
          {
            path: '/change-password',
            load: () =>
              import(
                /* webpackChunkName: "change-password" */ './ChangePassword.js'
              ),
          }
        ]
      },
      {
        path: '/app',
        component: Layout,
        routes: [
          {
            path: '/',
            component: () => <Redirect to={{ pathname: '/app/dashboard' }} />,
          },
          {
            path: '/dashboard',
            roles: ['administrator'],
            component: ({ route }) => (
              <DashboardProvider>
                {renderRoutes(route.routes)}
              </DashboardProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(/* webpackChunkName: "dashboard" */ './Dashboard.js'),
              },
            ],
          },
          {
            path: '/dashboard',
            roles: ['supervisor'],
            component: ({ route }) => (
              <DashboardProvider>
                {renderRoutes(route.routes)}
              </DashboardProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(/* webpackChunkName: "dashboard" */ './Dashboard.js'),
              },
            ],
          },
          {
            path: '/AddPDF',
            roles: ['administrator'],
            load: () =>
              import(
                /* webpackChunkName: "supervisor" */ './AssignedGuideView.js'
              ),
          },
          {
            path: '/change-password',
            load: () =>
              import(
                /* webpackChunkName: "change-password" */ './ChangePassword.js'
              ),
          },
          {
            path: '/supervisor',
            roles: ['administrator'],
            component: ({ route }) => (
              <SupervisorProvider>
                {renderRoutes(route.routes)}
              </SupervisorProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(
                    /* webpackChunkName: "supervisor" */ './Supervisor.js'
                  ),
              },
            ],
          },
          {
            path: '/intervenant',
            roles: ['administrator'],
            component: ({ route }) => (
              <IntervenorProvider>
                {renderRoutes(route.routes)}
              </IntervenorProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(
                    /* webpackChunkName: "intervenor" */ './Intervenant.js'
                  ),
              },
            ],
          },
          {
            path: '/contributors',
            component: ({ route }) => (
              <ContributorsProvider>
                {renderRoutes(route.routes)}
              </ContributorsProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(
                    /* webpackChunkName: "contributors" */ './Contributors.js'
                  ),
              },
            ],
          },
          {
            path: '/complaints',
            roles: ['administrator', 'supervisor'],
            component: ({ route }) => (
              <ComplaintsProvider>
                  <IntervenorProvider>
                {renderRoutes(route.routes)}
                  </IntervenorProvider>
              </ComplaintsProvider>
            ),
            routes: [
              {
                path: '/',
                load: () =>
                  import(
                    /* webpackChunkName: "Complaints" */ './Complaints.js'
                  ),
              },
            ],
          },
        ],
      },
      {
        path: '/login',
        load: () => import(/* webpackChunkName: "Login" */ './Login.js'),
      },
      {
        path: '/forget-password',
        load: () =>
          import(
            /* webpackChunkName: "ForgetPassword" */ './ForgetPassword.js'
          ),
      },
      {
        path: '/reset-password',
        load: () =>
          import(/* webpackChunkName: "ResetPassword" */ './ResetPassword.js'),
      },
      {
        path: '/delete-user-data',
        load: () =>
          import(/* webpackChunkName: "DeleteUserData" */ './DeleteUserData.js'),
      },
    ],
  },
]

export default processRoutes({
  routes,
  notFoundComponent: NotFound,
})
